import { HTTP } from './http-common'

export default {
  getOpeningsForZone(projectId, zoneId) {
    return HTTP.get(`/projects/${projectId}/openings?zoneId=${zoneId}`)
  },
  getOpeningByTag(projectId, tagId) {
    return HTTP.get(`/projects/${projectId}/openings/by_tag/${tagId}`)
  },
  getPhotosByOpening(projectId, openingId) {
    return HTTP.get(`/projects/${projectId}/openings/${openingId}/photos`)
  },
  addPhotoOpening(projectId, openingId, photoInfo) {
    return HTTP.post(`/projects/${projectId}/openings/${openingId}/photos`, photoInfo)
  },
  updateZone(projectId, zoneId, payload) {
    return HTTP.put(`/projects/${projectId}/zones/${zoneId}`, payload)
  },
  readZone(projectId, zoneId) {
    return HTTP.get(`/projects/${projectId}/zones/${zoneId}`)
  },
  updateOpening(projectId, openingId, opening) {
    return HTTP.put(`/projects/${projectId}/openings/${openingId}`, opening)
  },
  deletePhotoOpening(projectId, openingId, photoId) {
    return HTTP.delete(`/projects/${projectId}/openings/${openingId}/photos/${photoId}`)
  },
  deletePenetrantOpening(projectId, openingId, penetrantId) {
    return HTTP.delete(`/projects/${projectId}/openings/${openingId}/penetrants/${penetrantId}`)
  },
  editPenetrantOpening(projectId, openingId, penetrantId, payload) {
    return HTTP.put(`/projects/${projectId}/openings/${openingId}/penetrants/${penetrantId}`, payload)
  },
  addPenetrantOpening(projectId, openingId, payload) {
    return HTTP.post(`/projects/${projectId}/openings/${openingId}/penetrants`, payload)
  },
  addOpening(projectId, payload) {
    console.log(payload)
    return HTTP.post(`projects/${projectId}/openings/`, payload)
  }
}



// WEBPACK FOOTER //
// ./src/services/openingService.js